import { IProjectParameterConfiguration } from '../../interfaces/iproject-parameter-configuration';
import { ProjectType } from '../project-type';

export class ProjectParameterConfigurationBase {
  ProjectParameterConfigurationId: number;
  ProjectTypeId: number | null;
  ShowParameterTab: boolean | null;
  ParameterModule: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectType?: ProjectType;

  constructor(item?: IProjectParameterConfiguration) {
    if (item) {

      this.ProjectParameterConfigurationId = item.ProjectParameterConfigurationId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.ShowParameterTab = item.ShowParameterTab;
      this.ParameterModule = item.ParameterModule;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}